import React from 'react';
import './index.css'; // Import Tailwind CSS and global styles
import BodyShapeDietQuiz from './BodyShapeDietQuiz'; // Import your quiz component

function App() {
  return (
    <div className="App min-h-screen bg-gray-50">
      {/* Header Section */}
      <header className="bg-[#0096AD] p-6 text-white text-center shadow-md">
        <h1 className="text-3xl font-bold tracking-wide">
          Body Shape Diet Quiz
        </h1>
        <p className="text-gray-200 mt-2">
          Discover your diet type and lifestyle recommendations
        </p>
      </header>

      {/* Main Content Section */}
      <main className="p-6 max-w-3xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6 border border-gray-200">
          {/* Render the Quiz Component */}
          <BodyShapeDietQuiz />
        </div>
      </main>

      {/* Footer Section */}
      <footer className="bg-gray-800 text-white p-4 text-center mt-6">
        <p className="text-sm">
          &copy; {new Date().getFullYear()} Body Shape Diet Quiz. All rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default App;
